import React from "react";

const Sidebar = (props) => {
  return (
    <div className="sidebar fixed-left">
      <div className="bs-component">
        <nav className="navbar navbar-dark bg-primary">
          <div className="container-fluid sidebar__container">
            <div className="inner-nav" id="navbarColor01">
              <ul className="navbar-nav">{props.children}</ul>
            </div>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default Sidebar;
